import React, { FC } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import rL from './i18n/router';
import MisDatos from './pages/MisDatos';
import Revistas from './pages/Revistas';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Saldo from './pages/Saldo';
import PuntosTravel from './pages/PuntosTravel';
import Vales from './pages/Vales';
import ComprasTicket from './pages/ComprasTicket';
import Layout from './components/Layout';
import Ahorros from './pages/Ahorros';
import { StorageHelper } from './utils/StorageHelper';
import Tarjetas from './pages/Tarjetas';
import TarjetasOro from './pages/TarjetasOro';
import { HostProvider } from './utils/HostProvider';

if (HostProvider.isEroski()) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  import('./assets/scss/globals.scss');
} else {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  import('./assets/scss/globals-caprabo.scss');
}

const App: FC = () => {
  StorageHelper.initializeVars();

  return (
    <div>
      <Router>
        <Layout>
          <Switch>
            <Route
              exact
              path={['/', '/home', '/vacio.html', '/test.html']}
              component={Home}
            />
            <Route
              exact
              path={rL.getRutas('misdatos')}
              render={(props) => (
                <MisDatos
                  {...props}
                  showChangeMail={false}
                  showBaja={false}
                  showChangePass={false}
                />
              )}
            />
            <Route exact path={rL.getRutas('revistas')} component={Revistas} />
            <Route exact path={rL.getRutas('saldo')} component={Saldo} />
            <Route
              exact
              path={rL.getRutas('fueron-oro')}
              component={NotFound}
            />
            <Route exact path={rL.getRutas('ahorros')} component={Ahorros} />
            <Route
              exact
              path={rL.getRutas('puntos-travel')}
              component={PuntosTravel}
            />
            <Route exact path={rL.getRutas('vales')} component={Vales} />
            <Route
              exact
              path={rL.getRutas('compras')}
              component={ComprasTicket}
            />
            <Route exact path={rL.getRutas('tarjetas')} component={Tarjetas} />
            <Route
              exact
              path={rL.getRutas('tarjeta-oro')}
              component={TarjetasOro}
            />
            <Route
              exact
              path={rL.getRutas('change-mail')}
              render={(props) => <MisDatos {...props} showChangeMail />}
            />
            <Route
              exact
              path={rL.getRutas('change-pass')}
              render={(props) => <MisDatos {...props} showChangePass />}
            />
            <Route
              exact
              path={rL.getRutas('baja-digital')}
              render={(props) => <MisDatos {...props} showBaja />}
            />
            <Route component={NotFound} />
          </Switch>
        </Layout>
      </Router>
    </div>
  );
};
export default hot(module)(App);
